import React, { useState } from 'react';
import './ExploreContainer.css';
import axios from 'axios';
import Lottie from 'lottie-react';
import sucesss from '../Animation-1713413981309.json';

interface ContainerProps {
  name: string;
}

const BACKEND_URL = 'https://backend.party-snapper.com/api/image';
const HERO_IMG = 'https://upload.party-snapper.com/endlich.jpg';

const ExploreContainer: React.FC<ContainerProps> = () => {
  const [image, setImage] = useState<File | null>(null);
  const [preview, setPreview] = useState('');
  const [uploading, setUploading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [success, setSuccess] = useState(false);

  const openFileDialog = () => {
    document.getElementById('file-upload')?.click();
  };

  const captureImage = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => {
      if (reader.result) setPreview(reader.result.toString());
    };
    reader.readAsDataURL(file);
    setImage(file);
    setSuccess(false);
    event.target.value = '';
  };

  const handleCancel = () => {
    setUploading(false);
    setPreview('');
    setSuccess(false);
    setImage(null);
    setProgress(0);
  };

  const handleUpload = async () => {
    if (!image) return;
    const formData = new FormData();
    formData.append('file', image);
    setUploading(true);
    setProgress(0);
    try {
      await axios.post(BACKEND_URL, formData, {
        onUploadProgress: progressEvent => {
          if (!progressEvent.total) return;
          const pct = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          setProgress(pct);
          if (progressEvent.loaded >= progressEvent.total) {
            setUploading(false);
            setPreview('');
            setImage(null);
            setSuccess(true);
          }
        },
      });
    } catch (err) {
      console.error('Fehler beim Hochladen der Datei', err);
      setUploading(false);
    }
  };

  return (
    <div className="upload-page">
      <input
        type="file"
        id="file-upload"
        accept="image/*"
        style={{ display: 'none' }}
        onChange={captureImage}
      />

      <div className="upload-card">
        {!preview && !success && !uploading && (
          <>
            <img className="hero-img" src={HERO_IMG} alt="Jugendweihe 2026" />
            <p className="kicker">Jugendweihe · 2026</p>
            <h1 className="display-h1">Halte den Moment fest</h1>
            <p className="body-p">
              Nimm ein lustiges Foto, ein Selfie oder ein Gruppenbild auf
              und lade es hoch.
            </p>
            <p className="body-p emphasis">
              Dein Bild wird Teil einer einzigartigen Collage für Emma,
              die diesen Tag unvergesslich macht.
            </p>
            <p className="body-p">Mach mit und verewige deine Freude.</p>
            <button type="button" className="btn btn-primary" onClick={openFileDialog}>
              <CameraIcon /> Foto aufnehmen oder auswählen
            </button>
          </>
        )}

        {preview && !uploading && (
          <>
            <p className="kicker">Vorschau</p>
            <div className="preview-frame">
              <img src={preview} alt="Vorschau" />
            </div>
            <button type="button" className="btn btn-primary" onClick={handleUpload}>
              <UploadIcon /> Ins Album damit
            </button>
            <button type="button" className="btn btn-secondary" onClick={handleCancel}>
              Anderes Foto wählen
            </button>
          </>
        )}

        {uploading && (
          <>
            <p className="kicker">Lade hoch …</p>
            {preview && (
              <div className="preview-frame uploading">
                <img src={preview} alt="" />
              </div>
            )}
            <div className="progress-track" role="progressbar" aria-valuenow={progress} aria-valuemin={0} aria-valuemax={100}>
              <div className="progress-fill" style={{ width: `${progress}%` }} />
              <div className="progress-label">{progress}%</div>
            </div>
            <p className="body-p">Dein Bild wird zu Emmas Collage hinzugefügt.</p>
          </>
        )}

        {success && !preview && !uploading && (
          <>
            <div className="lottie-wrap">
              <Lottie animationData={sucesss} loop={false} />
            </div>
            <h2 className="display-h2">Geschafft!</h2>
            <p className="body-p">
              Dein Bild ist jetzt Teil von Emmas Collage. Danke, dass du
              dabei warst.
            </p>
            <button type="button" className="btn btn-primary" onClick={openFileDialog}>
              <CameraIcon /> Noch ein Foto hochladen
            </button>
          </>
        )}
      </div>
    </div>
  );
};

const CameraIcon: React.FC = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
       strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" />
    <circle cx="12" cy="13" r="4" />
  </svg>
);

const UploadIcon: React.FC = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
       strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
    <polyline points="17 8 12 3 7 8" />
    <line x1="12" y1="3" x2="12" y2="15" />
  </svg>
);

export default ExploreContainer;
